import { combineReducers } from 'redux'

import servicesReducer from "./data-services/reducers/servicesReducer";
import serviceDetailReducer from "./data-services/reducers/serviceDetailReducer";
import sourceDetailReducer from "./data-sources/reducers/sourceDetailReducer";
import providerDetailReducer from "./data-providers/reducers/providerDetailReducer";
import addEditRootReducer from "./add-edit/reducers/AddEditRootReducer";
import providersReducer from "./data-providers/reducers/providersReducer";
import billingGroupsReducer from "./billing-groups/reducers/BillingGroupsReducer";
import billingGroupsPricingReducer from "./billing-groups/reducers/BillingGroupsPricingReducer";
import kybServicesReducer from "./data-services/reducers/KYBServicesReducer";
import breadcrumbReducer from './breadcrumb/BreadcrumbReducer';
import countriesReducer from "./country-coverage/reducers/countriesReducer";
import countryDetailReducer from "./country-coverage/reducers/countryDetailReducer";

const veritasRootReducer = combineReducers({
    services: servicesReducer,
    kybServices: kybServicesReducer,
    providers: providersReducer,
    billingGroups: billingGroupsReducer,
    billingGroupsPricing: billingGroupsPricingReducer,
    countries: countriesReducer,
    countryDetail: countryDetailReducer,
    serviceDetail: serviceDetailReducer,
    sourceDetail: sourceDetailReducer,
    providerDetail: providerDetailReducer,
    addEdit: addEditRootReducer,
    breadcrumb: breadcrumbReducer
});

export default veritasRootReducer;
